import { Shimmer } from "component-library";

import "./SkeletonCard.scss";

export const SkeletonCard = () => (
  <div className="c-performer-grid-stub">
    <div className="c-performer-grid-stub__image">
      <Shimmer />
    </div>
    <div className="c-performer-grid-stub__text">
      <Shimmer />
    </div>
    <div className="c-performer-grid-stub__text c-performer-grid-stub__text--long">
      <Shimmer />
    </div>
  </div>
);
